export const ACTIONS = {
  GET_ALL_PRODUCTS_LOADING: 'PRODUCTS:STAND_ALONE:GET_ALL_PRODUCTS_LOADING',
  GET_ALL_PRODUCTS_SUCCESS: 'PRODUCTS:STAND_ALONE:GET_ALL_PRODUCTS_SUCCESS',
  GET_ALL_PRODUCTS_ERROR: 'PRODUCTS:STAND_ALONE:GET_ALL_PRODUCTS_ERROR',
  SET_TOTAL_COST_TERM: 'PRODUCTS:STAND_ALONE:SET_TOTAL_COST_TERM',
  SAVE_SEARCH_CRITERIA: 'PRODUCTS:STAND_ALONE:SAVE_SEARCH_CRITERIA',
  SET_REPAYMENT_FREQUENCY: 'PRODUCTS:STAND_ALONE:SET_REPAYMENT_FREQUENCY',
  RESET_REPAYMENTS_FREQUENCY: 'PRODUCTS:STAND_ALONE:RESET_REPAYMENTS_FREQUENCY',
};
